export interface AreaSeoInfo {
  areaResourceId: string;
  searchSlug: string;
}
const controller = {
  /**
   * Extracts SEO information from the given pathname.
   *
   * @param {string} pathname - The pathname to extract SEO information from.
   *                            Expected format: `/{areaResourceId}/{searchSlug}`
   * @returns {AreaSeoInfo}
   */
  getAreaSeoInfo(pathname: string): AreaSeoInfo {
    const pathnameParts = pathname.split('/');
    const areaResourceId = pathnameParts[1];
    const searchSlug = pathnameParts[2];

    return { areaResourceId, searchSlug };
  },
};

export default controller;
